//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getInfoApi } from '@/api/device';
import Vue from 'vue';
import base64 from 'base-64';
export default {
  name: 'detectionData',
  components: {
    examineDialog: function examineDialog() {
      return import('./examineDialog');
    }
  },
  props: {
    formInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  filters: {
    filterStatus: function filterStatus(status) {
      if (status == 'success') {
        return '正常';
      } else if (status == 'waring') {
        return '异常';
      } else {
        return '重大事故';
      }
    }
  },
  data: function data() {
    return {
      viewData: {
        status: {
          shigu: {},
          shuipao: {},
          huoshao: {}
        }
      },
      carid: '14'
    };
  },
  mounted: function mounted() {
    this.getData();
  },
  methods: {
    getData: function getData() {
      var _this = this;
      this.carid = this.formInfo.data.id;
      var data = {
        carid: this.carid,
        do: "baogao"
      };
      getInfoApi(data).then(function (res) {
        if (res.data && Array.isArray(res.data.deviceList)) {
          _this.viewData = Object.assign({
            status: {
              shigu: {},
              shuipao: {},
              huoshao: {}
            },
            deviceList: [],
            img: [],
            imgmore: []
          }, res.data);
        }
      });
    },
    examineItem: function examineItem(id) {
      this.$refs.examineDialog.handleOpen(JSON.parse(JSON.stringify(this.viewData.shFormData)), id);
    },
    isOk: function isOk(config, id) {
      var _this2 = this;
      var json = base64.encode(encodeURIComponent(JSON.stringify(config)));
      var data = {
        carid: this.carid,
        id: id,
        do: "shzsgc",
        type: 'save',
        json: json
      };
      getInfoApi(data).then(function (res) {
        if (res.data) {
          _this2.$message.success('提交成功');
          _this2.getData();
        }
      });
    }
  }
};